<script>
	export let txt;
</script>

<p>
	{txt}
</p>

<style>
	p {
		font-size: x-large;
		color: rgb(103, 89, 122);
	}
</style>
